<!--Back Button-->
<div class="container">
  <div class="d-none d-lg-block back-button-padding">
    <button class="back-btn border-0 d-flex align-items-center justify-content-center" [routerLink]="'/rewards/raffles'">
      <span class="material-icons text-white">arrow_back_ios_new</span>
    </button>
  </div>
</div>

<!--Point Summary Bar-->
<fgb-points-summary-bar [backButtonTitle]="'Raffles'"></fgb-points-summary-bar>

<!--Lotto Details-->
<fgbcl-lotto-details-v2 [lottoId]="id" />
